import { Select } from 'antd';
import { SelectOption } from 'types';
const SelectComponent = ({
  onSelectionChange,
  data,
  placeholder,
  value,
  disabled = false,
}: {
  onSelectionChange?: (data: SelectOption) => void;
  data?: SelectOption[];
  placeholder?: string;
  value: SelectOption;
  disabled: boolean;
}) => {
  return (
    <div>
      <Select
        defaultValue={value}
        showSearch
        style={{ width: '100%' }}
        placeholder={placeholder}
        optionFilterProp='label'
        onSelect={onSelectionChange}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        }
        options={data}
        disabled={disabled}
      />
    </div>
  );
};

export default SelectComponent;
